import { UserInformation } from '../../api/client'

export default (field: keyof UserInformation): string =>
  ({
    first: 'First name',
    last: 'Last Name',
    address: 'Address',
    timezone: 'Timezone',
  }[field])
